<p-toast key="error"></p-toast>
<router-outlet></router-outlet>
<lib-ui-version-update-modal
  [visible]="showVersionUpdateModal"
  [currentVersion]="currentVersion"
  [newVersion]="newVersion"
  [appName]="'Portal'"
  [isRollback]="isRollback"
  (accept)="onVersionUpdateAccept()"
  (modalClose)="onVersionUpdateModalClose()">
</lib-ui-version-update-modal>
